import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LayoutBase } from '../../../../../../layouts';
import { EmergencyLevels, EmergencySituation, GeneralPae, Rupture, ToolsDetails } from '../../../../../../components/custom';
import { Box, Button, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { INiveisEmergencia, IPae, IRupturaHipotetica, ISituacaoEmergencia, PaeServices } from '../../../../../../services/api/action-plan/Pae';
import React from 'react';
import { NavigateBefore, NavigateNext, Save } from '@mui/icons-material';
import { CustomAlert } from '../../../../../../components/shared';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const EmergencyPlanDetails = () => {
  const [error, setError] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });


  const url = useParams();

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const { actionId, id } = useParams();
  const [data, setData] = useState<IPae>();


  const handleChangeButtonNext = () => {
    if (value < 3) {
      validateData(value);
      // setValue(value + 1);
    }
  };

  const handleChangeButtonBefor = () => {
    if (value > 0) {
      setValue(value - 1);
    }
  };

  function validateData(value: number) {
    if (value === 0) {
      if (data?.data_emissao === '') {
        // setAlertInfo({open: true, message: 'Data de emissão é obrigatória', severity: 'warning'});
        setError(true);
      } else {
        setError(false);
        setValue(value + 1);
        // setAlertInfo({open: false, message: '', severity: 'success'});
      }
    } else if (value === 1) {
      setValue(value + 1);
    } else if (value === 2) {
      setValue(value + 1);
    }
  }

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  //Components
  const handleEmergencyDataChange = (value: ISituacaoEmergencia) => {
    setData(prevData => { if (prevData) { return { ...prevData, situacaoEmergencia: value }; } return { situacaoEmergencia: value } as IPae; });
  };

  const handleRuptureDataChange = (value: IRupturaHipotetica) => {
    setData(prevData => { if (prevData) { return { ...prevData, estudoRuptura: value }; } return { estudoRuptura: value } as IPae; });
  };

  const handleEmergencyLevelDataChange = (value: INiveisEmergencia[]) => {
    setData(prevData => {
      if (prevData) {
        return { ...prevData, niveisEmergencia: value };
      }
      return { niveisEmergencia: value } as IPae;
    });
  };

  const handleGeneralDataChange = (value: IPae) => {
    setData(value);
  };

  useEffect(() => {
    setData({
      id_barragem: '',
      empresa_executora: '',
      responsavel_tecnico: '',
      art: '',
      orgao_fiscalizador: '',
      data_emissao: '',
      situacaoEmergencia: {},
      estudoRuptura: {},
      niveisEmergencia: [],
    });
    fetchData();
  }, [location.pathname]);

  const fetchData = () => {
    if (actionId !== 'novo' && actionId !== undefined) {
      PaeServices.get(actionId)
        .then((response) => {
          if (response instanceof Error) {
            setAlertInfo({ open: true, message: `Error: ${response.message}`, severity: 'warning' });
          } else {
            setData(response);
          }
        });
    }
  };

  const handleSave = () => {
    if (data != undefined && actionId == 'novo') {
      data.id_barragem = id;
      PaeServices.create(data)
        .then((response) => {
          if (response instanceof Error) {
            setAlertInfo({ open: true, message: `Error ao salvar: ${response.message}`, severity: 'error' });
          } else {
            setAlertInfo({ open: true, message: 'PAE salvo com sucesso', severity: 'success' });
            setTimeout(() => {
              navigate(`/information_dam/${url.id}/emergency_plan`);
            }, 2000);
          }
        });

    } else {
      if (actionId !== undefined && data !== undefined) {
        delete data.uuid;
        PaeServices.upgrade(data, actionId)
          .then((response) => {
            if (response instanceof Error) {
              setAlertInfo({ open: true, message: `Error: ${response.message}`, severity: 'error' });
            } else {
              setAlertInfo({ open: true, message: 'Registro atualizado', severity: 'success' });
              fetchData();
              setTimeout(() => {
                navigate(`/information_dam/${url.id}/emergency_plan`);
              }, 2000);
            }
          });
      }
    }
  };

  const handleDelete = () => {
    if (actionId) {
      PaeServices.delet(actionId)
        .then((response) => {
          if (response instanceof Error) {
            setAlertInfo({ open: true, message: `Error ao deletetar: ${response.message}`, severity: 'error' });
            console.log(response.message);
          } else {
            setAlertInfo({ open: true, message: 'PAE deletado', severity: 'success' });
            navigate(`/information_dam/${id}/emergency_plan`);
          }
        });
    }
  };

  const handleNew = () => {
    navigate(`/information_dam/${id}/semiannual_internal_training/detalhes/novo`);
  };

  return (
    <LayoutBase
      title='Cadastro plano de ação de emergência'
      tollBar={<ToolsDetails
        showSaveButton={false}
        onClickDelet={() => handleDelete()}
        onClickNew={() => handleNew()}
      />}
    >
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab disabled sx={{ '&.Mui-disabled': theme.palette.primary.main }} label="INFORMAÇÕES GERAIS DO PAE" {...tabProps(0)} />
            <Tab disabled sx={{ '&.Mui-disabled': theme.palette.primary.main }} label="STATUS DA SITUAÇÃO DE EMERGÊNCIA" {...tabProps(1)} />
            <Tab disabled sx={{ '&.Mui-disabled': theme.palette.primary.main }} label="CARACTERÍSTICAS DO ESTUDO DE RUPTURA HIPOTÉTICA" {...tabProps(2)} />
            <Tab disabled sx={{ '&.Mui-disabled': theme.palette.primary.main }} label="DEFINIÇÃO DOS NÍVES DE EMERGÊNCIA" {...tabProps(3)} />
          </Tabs>
        </Box>
        <Box>
          <Box padding={1} display={'flex'} justifyContent={'space-between'} flexDirection={smDown ? 'column' : 'row'} gap={smDown ? '5px' : 0}>
            <Button
              variant='contained'
              sx={{ borderRadius: '25px' }}
              startIcon={<NavigateBefore />}
              disabled={value == 0}
              onClick={() => handleChangeButtonBefor()}
            >Voltar</Button>
            <Button
              variant='contained'
              sx={{ borderRadius: '25px' }}
              startIcon={value != 3 ? <NavigateNext /> : <Save />}
              onClick={value != 3 ? () => handleChangeButtonNext() : () => handleSave()}
            >{value != 3 ? 'Proximo' : 'Salvar'}</Button>

          </Box>
          <CustomTabPanel value={value} index={0}>
            <GeneralPae smDown={smDown} value={data} onChange={handleGeneralDataChange} error={error} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <EmergencySituation smDown={smDown} value={data?.situacaoEmergencia} onChange={handleEmergencyDataChange} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Rupture smDown={smDown} value={data?.estudoRuptura} onChange={handleRuptureDataChange} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <EmergencyLevels smDown={smDown} value={data?.niveisEmergencia} onChange={handleEmergencyLevelDataChange} />
          </CustomTabPanel>
        </Box>
      </Box>
      {alertInfo.open &&
        <CustomAlert
          severity={alertInfo.severity}
          message={alertInfo.message}
        />
      }
    </LayoutBase>
  );
};